import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorActiveOrders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M19.11 6.926c.145.192.223.426.223.667v8.63c0 .613-.497 1.11-1.11 1.11H9.777a1.111 1.111 0 0 1-1.112-1.11V4.777c0-.614.498-1.111 1.112-1.111h6.333c.35 0 .679.164.889.444l2.11 2.815Zm-4.777 11.74H9.778a2.444 2.444 0 0 1-2.445-2.444V6.667H5.778c-.614 0-1.111.497-1.111 1.11v11.445c0 .614.497 1.111 1.11 1.111h7.445c.614 0 1.111-.497 1.111-1.11v-.556Zm1.333 0v.556a2.444 2.444 0 0 1-2.444 2.445H5.778a2.444 2.444 0 0 1-2.445-2.445V7.778a2.444 2.444 0 0 1 2.445-2.445h1.555v-.555a2.444 2.444 0 0 1 2.445-2.445h6.333c.77 0 1.494.363 1.956.978l2.11 2.815c.318.423.49.938.49 1.467v8.63a2.444 2.444 0 0 1-2.445 2.444h-2.556Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M15 9.75a.75.75 0 0 0 0-1.5h-4a.75.75 0 0 0 0 1.5h4Zm2 3a.75.75 0 0 0 0-1.5h-6a.75.75 0 0 0 0 1.5h6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorActiveOrders;
